import { Icon } from './Icon';

export default function PageLoader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[100]">
      <div className="flex space-x-3">
        <Icon name="logo-heart" className="size-10 heart-svg" />
        <Icon name="logo-heart" className="size-10 heart-svg" />
        <Icon name="logo-heart" className="size-10 heart-svg" />
      </div>
    </div>
  );
}
